import { Box, Typography } from '@mui/material';
import { ArcElement, Chart as ChartJS } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement);

export const ScoreDonut = ({
  score,
  color,
}: {
  score: number;
  color: string;
}) => {
  const stroke = 10;
  const size = 100;
  const normalizedRadius = size / 2 - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  return (
    <Box
      sx={{
        position: 'relative',
        pointerEvents: 'none',
        width: size,
        height: size,
      }}>
      <Doughnut
        data={{
          datasets: [
            {
              data: [score, 100 - score],
              borderRadius: 15,
              backgroundColor: [color, 'transparent'],
              borderColor: [color, 'transparent'],
            },
          ],
          labels: [],
        }}
        options={{
          cutout: '80%',
          backgroundColor: 'white',
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
            datalabels: {
              display: false,
            },
          },
        }}
      />
      {/* Background disc for animating chart to sit on */}
      <svg
        height={size}
        width={size}
        style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={normalizedRadius}
          stroke="white"
          strokeDasharray={`${circumference}, ${circumference}`}
          strokeWidth={stroke}
        />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}>
        <Typography variant="h3" sx={{ mb: 0.5 }}>
          {score}%
        </Typography>
        <Typography variant="body3">score</Typography>
      </Box>
    </Box>
  );
};
